import React from "react";
import { StatusBadgeProps } from "./status-badge.props";

const StatusBadge: React.FC<StatusBadgeProps> = (props: StatusBadgeProps) => {
  return (
    <div
      className={`inline-flex items-center px-2 py-0.5 border rounded-full text-[12px] font-medium leading-none whitespace-nowrap ${props.style}`}
    >
      <span>{props.status}</span>
    </div>
  );
};

export { StatusBadge };
